// CR-20261009-001 L3.4 (D528 A): on an RM-hosted meeting the site camera's link is made only through Helix — from
// ClikWork, after the builder registration is sent. The host's screen can show a link Helix already made; it never
// makes or replaces one (Canvas answers 409 `site_via_crm`). A meeting without siteVia keeps today's box.
export const siteViaCrm = (meeting) => meeting?.siteVia === "helix";

export const SITE_VIA_CRM = "Get the site link from Workin.";
export const SITE_VIA_CRM_NEW = "A new link comes from Workin too.";

// What the box offers, from the meeting's record and what Canvas last answered. `refused` is the 409 site_via_crm.
//   "make"  — today's: Make a link / Copy / WhatsApp / New link
//   "crm"   — no link yet: the words, no button
//   "shown" — Helix made one: the link with Copy, and New link pointing to ClikWork
export function siteBoxMode(meeting, { siteUrl = "" } = {}) {
  if (!siteViaCrm(meeting)) return "make";
  return siteUrl ? "shown" : "crm";
}

// Whether an error from /api/site is Canvas saying "from ClikWork".
export const isSiteViaCrm = (err) => err?.status === 409 && err?.data?.code === "site_via_crm";
